import { AppThunkAction } from "..";
import { KnownAction, IProfileCategory, IProfile, ICategories, REPIQ_PRESET_PROFILE, SHOW_LOADER } from "./types";
import * as services from "../service";
import { groupByValue } from "../../util/common";

export const actionCreators = {
    getPresetProfileData: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({ type: SHOW_LOADER, isLoading: true });
        const appState = getState();
        if (
            appState &&
            appState.repIQPresetProfileState &&
            appState.repIQPresetProfileState.presetProfileData &&
            appState.repIQPresetProfileState.presetProfileData.length > 0
        ) {
            dispatch({ type: SHOW_LOADER, isLoading: false });
        } else {
            services
                .getPresetProfile()
                .then((data) => {
                    if (data && data.length > 0) {
                        let presetProfileData: IProfileCategory[] = [];
                        let profileCategories = groupByValue(data, "profileCategoryName");

                        Object.keys(profileCategories).forEach((key: any) => {
                            let profCat: IProfileCategory = { profileCategoryID: profileCategories[key][0].categoryID, profileCategoryName: key, profiles: [] };
                            let profiles = groupByValue(profileCategories[key], "profileName");

                            Object.keys(profiles).forEach((profKey: any) => {
                                let categories = groupByValue(profiles[profKey], "categoryName");
                                let category: ICategories = {
                                    Agreeableness: { high: 0, low: 0 },
                                    Conscientiousness: { high: 0, low: 0 },
                                    EmotionalRange: { high: 0, low: 0 },
                                    Extraversion: { high: 0, low: 0 },
                                    OpennessToExperiences: { high: 0, low: 0 },
                                };

                                Object.keys(categories).forEach((catKey: any) => {
                                    if (catKey === "Agreeableness") {
                                        category.Agreeableness.high = categories[catKey][0].maxValue * 100;
                                        category.Agreeableness.low = categories[catKey][0].minValue * 100;
                                    } else if (catKey === "Conscientiousness") {
                                        category.Conscientiousness.high = categories[catKey][0].maxValue * 100;
                                        category.Conscientiousness.low = categories[catKey][0].minValue * 100;
                                    } else if (catKey === "EmotionalRange") {
                                        category.EmotionalRange.high = categories[catKey][0].maxValue * 100;
                                        category.EmotionalRange.low = categories[catKey][0].minValue * 100;
                                    } else if (catKey === "OpennessToExperiences") {
                                        category.OpennessToExperiences.high = categories[catKey][0].maxValue * 100;
                                        category.OpennessToExperiences.low = categories[catKey][0].minValue * 100;
                                    } else if (catKey === "Extraversion") {
                                        category.Extraversion.high = categories[catKey][0].maxValue * 100;
                                        category.Extraversion.low = categories[catKey][0].minValue * 100;
                                    }
                                });

                                profiles[profKey] = categories;

                                let prof: IProfile = {
                                    profileName: profiles[profKey].Agreeableness[0].profileName,
                                    profileID: profiles[profKey].Agreeableness[0].profileID,
                                    categories: category,
                                };
                                profCat.profiles.push(prof);
                            });
                            profileCategories[key] = profiles;
                            presetProfileData.push(profCat);
                        });

                        dispatch({ type: REPIQ_PRESET_PROFILE, repIQPresetProfileData: presetProfileData });
                        dispatch({ type: SHOW_LOADER, isLoading: false });
                    }
                })
                .catch(function (error) {
                    dispatch({ type: SHOW_LOADER, isLoading: false });
                });
        }
    },
};
